import About from "../../../components/common/about";

const AboutPage = () => {
    return (

        <About/>
    )
}

export default AboutPage;